import * as L from 'leaflet';

// Color icons
export const greenIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const yellowIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const greyIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-grey.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const blueIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

// Special icons


export const addIcon = new L.Icon({
    //Attribution: MGalloway (WMF), CC BY-SA 4.0 <https://creativecommons.org/licenses/by-sa/4.0>, via Wikimedia Commons
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/OOjs_UI_icon_mapPinAdd-ltr.svg/240px-OOjs_UI_icon_mapPinAdd-ltr.svg.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 25],
  //iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [1, 1]
});

export const homeIcon = new L.Icon({
    //Attribution: ipapun, CC BY 3.0 
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/6/66/Home_icon_blue-1.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [30, 30],
  //iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [1, 1]
});

export const eventIcon = new L.Icon({
    //iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Map_marker_icon_%E2%80%93_Nicolas_Mollet_%E2%80%93_Group_%E2%80%93_People_%E2%80%93_Default.png',
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-violet.png', 
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const publicBookcaseIcon = new L.Icon({
  iconUrl: 'https://wiki.openstreetmap.org/w/images/b/b2/Public_bookcase-14.svg',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const aedIcon = new L.Icon({
  iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/4b/ISO_7010_E010.svg',
  // author: MaxxL
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const giveBoxIcon = new L.Icon({
  iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/90/Box-archive-solid.svg',
  // author: Font Awesome
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [20, 31],
  iconAnchor: [12, 31],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const drinkingWaterIcon = new L.Icon({
  iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/5/52/OCHA_humicons_water.png',
  // http://www.unocha.org/story/ocha-launches-500-free-humanitarian-symbols, CC BY-SA 4.0 <https://creativecommons.org/licenses/by-sa/4.0>, via Wikimedia Commons
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 31],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});

export const freeShopIcon = new L.Icon({
  iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/8/86/Shop_%2850373%29_-_The_Noun_Project.svg',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -20],
  shadowSize: [41, 41]
});


export const foodSharingIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/5/56/FoodBankGreen.png',
    //Designed by Ellenjhinds, CC BY-SA 4.0, via Wikimedia Commons
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [31, 31],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [41, 41]
});

export const foodBankIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/d/d2/Food_Bank_icon.svg',
    //Designed by Iconathlon as a collaboration with Edward Boatman., CC0, via Wikimedia Commons
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [41, 41]
});

export const soupKitchenIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Soup_Kitchen_-_The_Noun_Project.svg',
    //Iconathon, CC0, via Wikimedia Commons
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [32, 32],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [32, 32]
});

export const fallingfruitIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/c/c7/Fruit_Picking_-_The_Noun_Project.svg',
    //Iconathon, CC0, via Wikimedia Commons
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [41, 41]
});



export const repairCafeIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Deepin_Icon_Theme_%E2%80%93_deepin-repair-tools_%2822%29.svg',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [32, 32],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [41, 41]
});


export const volunteerIcon = new L.Icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Map_Icon_-_Service.png/250px-Map_Icon_-_Service.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [32, 32],
    iconAnchor: [12, 41],
    popupAnchor: [0, -20],
    shadowSize: [41, 41]
});
